import { render } from "./SejaFranqueado.vue?vue&type=template&id=8b41fdce&scoped=true"
import script from "./SejaFranqueado.vue?vue&type=script&lang=js"
export * from "./SejaFranqueado.vue?vue&type=script&lang=js"

import "./SejaFranqueado.vue?vue&type=style&index=0&id=8b41fdce&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b41fdce"]])

export default __exports__